/**
 * Round gold-on-navy badge displaying the agent's ordinal number
 * (e.g. "01" for Functional, "02" for Architect).
 *
 * Extracted from the Functional Workbench so other agents using the
 * "workbench" variant of AgentPageLayout can render the same glyph.
 */
interface CompactAgentGlyphProps {
  number: number;
  /** When set, renders the dot indicator (used to mark the active agent). */
  live?: boolean;
}

export function CompactAgentGlyph({ number, live = false }: CompactAgentGlyphProps) {
  return (
    <div className="relative w-[54px] h-[54px] flex-shrink-0">
      <div
        className="absolute inset-0 rounded-full"
        style={{ border: "1.2px solid rgba(255,200,61,0.35)" }}
      >
        {live && (
          <span
            aria-hidden="true"
            className="absolute -top-[2.5px] left-1/2 -ml-[2.5px] w-[5px] h-[5px] rounded-full"
            style={{ background: "#ffc83d", boxShadow: "0 0 8px #ffc83d" }}
          />
        )}
      </div>
      <div
        className="absolute inset-1.5 rounded-full flex items-center justify-center font-brand font-extrabold text-base text-[#08254c]"
        style={{
          background:
            "radial-gradient(circle at 35% 30%, #ffd96a, #ffc83d 50%, #b57a00)",
        }}
      >
        {String(number).padStart(2, "0")}
      </div>
    </div>
  );
}
